import axios from "axios";
import setAuthorizationToken from "./utils/setAuthorizationToken";


let host = process.env.REACT_APP_API_URL;
let filter = {
  where: {
    active: true
  }
};

export default {
  auth: {
    login: userData =>
      axios.post(host + "auth/user/login", userData).then(res => res.data),

    getUsers: orgId =>
      axios.get(host + `user/listUsers?orgId=${orgId}`).then(res => res.data),

    changePassword: data =>
      axios.put(host + "auth/user/change-password", data).then(res => res.data),

    resetPassword: (data, token) => {
      return axios.put(host + `auth/user/reset-password?token=${token}`, data).then(res => res.data)
    },

    editUser: data =>
      axios.put(host + "user/update-details", data).then(res => res.data),
    createUser: data =>
      axios.post(host + "auth/user/register", data).then(res => res.data),

    forgotPassword: data => axios.post(host + "auth/user/forgot-password", data).then(res => res.data),

    adminResetPassword: (data) => {
      return axios.put(host + `auth/user/admin-reset-password`, data).then(res => res.data)
    },
  },

  prescriptions: {
    getPrescriptions: (orgId, branchName) =>
      axios
        .get(
          host +
          `prescription?orgId=${orgId}&${branchName}&prescriptionStatus=Draft&prescriptionStatus=Rejected&prescriptionStatus=Pending`
        )
        .then(res => res.data),

    getDurInfo: prescription =>
      axios
        .post("https://prod-api.telerx.io/prescription/durinfo", prescription)
        .then(res => res.data),

    getApprovedPrescriptions: (orgId, branchName) =>
      axios
        .get(
          host +
          `prescription?orgId=${orgId}&${branchName}&prescriptionStatus=Approved`
        )
        .then(res => res.data),

    getDispensedPrescriptions: (orgId, branchName) =>
      axios
        .get(
          host +
          `prescription?orgId=${orgId}&${branchName}&prescriptionStatus=Dispensed`
        )
        .then(res => res.data),

    getPrescriptionsById: (orgId, branchName, patientId, prescriptionStatus) =>
      axios
        .get(
          host +
          `prescription?orgId=${orgId}&branchName=${branchName}&patientId=${patientId}&prescriptionStatus=${prescriptionStatus}`
        )
        .then(res => res.data),

    postPrescriptions: (orgId, branchName, prescriptionData) =>
      axios
        .put(
          host + `prescription?orgId=${orgId}&branchName=${branchName}`,
          prescriptionData
        )
        .then(res => res.data),

    dispensePrescription: (orgId, branchName, prescriptionData) =>
      axios
        .put(
          host + `prescriptions?orgId=${orgId}&branchName=${branchName}`,
          prescriptionData
        )
        .then(res => res.data),


    getPrescriptionByNumber: (orgId, branchName, prescriptionNumber, prescriptionStatus) =>
      axios
        .get(
          host +
          `prescription?orgId=${orgId}&${branchName}&prescriptionNumber=${prescriptionNumber}&prescriptionStatus=${prescriptionStatus}`
        )
        .then(res => res.data),

    getPrescriptionByStatus: (orgId, branchName, prescriptionStatus) =>
      axios
        .get(
          host +
          `prescription?orgId=${orgId}&${branchName}&prescriptionStatus=${prescriptionStatus}`
        )
        .then(res => res.data),

    getPrescriptionHistory: (orgId, branchName, patientId) =>
      axios
        .get(
          host +
          `prescriptionHistory?orgId=${orgId}&branchName=${branchName}&patientId=${patientId}`
        )
        .then(res => res.data)
  }
};
